export default __webpack_public_path__ + "static/tiara-5cb42e192e5648aecb7a7f21dc8da529.png";